import { __ } from '@wordpress/i18n';
import './Preloader.css';

const Preloader = ({ 
  stage = __("Preparing your dashboard...", "havenlytics"),
  progress = 0,
  showProgress = true 
}) => {
  return (
    <div className="hvnly-settings-preloader">
      <div className="hvnly-settings-preloader__content">
        {/* Ultra Minimalist Property Icon */}
        <div className="hvnly-settings-preloader__icon-wrapper">
          <div className="hvnly-settings-preloader__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
              {/* Simple roof */}
              <path d="M3 10L12 3L21 10" />
              {/* House body */}
              <rect x="5" y="10" width="14" height="11" rx="0.5" />
              {/* Door */}
              <rect x="10" y="15" width="4" height="6" rx="0.5" />
              {/* Window left */}
              <rect x="7" y="12" width="2" height="2" rx="0.2" />
              {/* Window right */}
              <rect x="15" y="12" width="2" height="2" rx="0.2" />
            </svg>
          </div>
        </div>
        
        {/* Title */}
        <h2 className="hvnly-settings-preloader__title">
          {__("Settings Dashboard", "havenlytics")}
        </h2>
        
        {/* Loading Stage Text */}
        <p className="hvnly-settings-preloader__stage">{stage}</p>
        
        {/* Progress Bar */}
        {showProgress && (
          <div className="hvnly-settings-preloader__progress-wrapper">
            <div className="hvnly-settings-preloader__progress-track">
              <div 
                className="hvnly-settings-preloader__progress-bar" 
                style={{ width: `${progress}%` }}
              />
            </div>
            <div className="hvnly-settings-preloader__progress-stats">
              <span className="hvnly-settings-preloader__progress-percent">
                {Math.round(progress)}%
              </span>
              <span className="hvnly-settings-preloader__progress-label">
                {__("Loading Complete", "havenlytics")}
              </span>
            </div>
          </div>
        )}
        
        {/* Loading Tips */}
        <div className="hvnly-settings-preloader__tips">
          <i className="fas fa-lightbulb"></i>
          <p>
            {__("💡 Tip: Configure your settings to optimize your property management workflow", "havenlytics")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Preloader;